import { Expose } from 'class-transformer';
import { SurveyElement } from './element';

export class SurveySelectFacilityElement extends SurveyElement {
  @Expose({ name: 'city_label' })
  cityLabel!: string;

  @Expose({ name: 'city_placeholder' })
  cityPlaceholder!: string;

  @Expose({ name: 'facility_label' })
  facilityLabel!: string;

  @Expose({ name: 'facility_placeholder' })
  facilityPlaceholder!: string;

  @Expose({ name: 'selected_facility_label' })
  selectedFacilityLabel!: string;

  @Expose({ name: 'change_facility_button_text' })
  changeFacilityButtonText!: string;
}
